// extracted by mini-css-extract-plugin
export default {"openNotesEditor":"_2XztY","noNotesYet":"_1Vr9B","notesLabel":"_2mRN3","addNotesLabel":"_22WHj","minimal":"_2VMOA","editIcon":"_2D_zO","hashtagSuggestions":"_2bCGG"};